import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-olive text-cream/60 py-8 text-center text-sm" data-id="element-60">
        <div className="max-w-7xl mx-auto px-4" data-id="element-61">
          <p className="mb-3" data-id="element-62">
            © {new Date().getFullYear()} Clean Slate Latina. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-63">
            <button onClick={() => setShowPrivacy(true)} className="underline underline-offset-2 hover:text-cream transition-colors duration-200" data-id="element-64">
              Política de Privacidad
            </button>
            <span className="text-cream/30" data-id="element-65">|</span>
            <button onClick={() => setShowTerms(true)} className="underline underline-offset-2 hover:text-cream transition-colors duration-200" data-id="element-66">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-67">
        <p className="font-semibold text-olive" data-id="element-68">
          Última actualización: Marzo 2026
        </p>

        <p data-id="element-69">
          En Clean Slate Latina, respetamos y protegemos tu privacidad. Esta
          política describe cómo recopilamos, usamos y protegemos tu información
          personal cuando adquieres nuestros productos digitales.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-70">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-71">
          Al realizar una compra, recopilamos únicamente la información
          necesaria para procesar tu pedido y entregarte el producto digital:
        </p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-72">
          <li data-id="element-73">Nombre completo</li>
          <li data-id="element-74">Dirección de correo electrónico</li>
          <li data-id="element-75">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-76">
          2. Uso de la Información
        </h3>
        <p data-id="element-77">Tu información personal se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-78">
          <li data-id="element-79">Procesar y entregar tu compra digital</li>
          <li data-id="element-80">Enviarte el producto adquirido a tu correo electrónico</li>
          <li data-id="element-81">Comunicarnos contigo respecto a tu pedido si es necesario</li>
        </ul>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-82">
          3. Protección de Datos
        </h3>
        <p data-id="element-83">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. No almacenamos datos de tarjetas de
          crédito en nuestros servidores. Todos los pagos son procesados a
          través de plataformas de pago seguras y encriptadas.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-84">
          4. Compartir Información
        </h3>
        <p data-id="element-85">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cuando
          la ley lo requiera.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-86">
          5. Tus Derechos
        </h3>
        <p data-id="element-87">Tienes derecho a:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-88">
          <li data-id="element-89">Acceder a la información personal que tenemos sobre ti</li>
          <li data-id="element-90">Solicitar la corrección de datos inexactos</li>
          <li data-id="element-91">Solicitar la eliminación de tus datos personales</li>
        </ul>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-92">
          6. Cookies
        </h3>
        <p data-id="element-93">
          Nuestro sitio web puede utilizar cookies esenciales para mejorar tu
          experiencia de navegación. No utilizamos cookies de seguimiento
          publicitario.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-94">
        <p className="font-semibold text-olive" data-id="element-95">
          Última actualización: Marzo 2026
        </p>

        <p data-id="element-96">
          Al adquirir cualquier producto digital de Clean Slate Latina, aceptas
          los siguientes términos y condiciones. Por favor, léelos
          cuidadosamente antes de realizar tu compra.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-97">
          1. Producto Digital
        </h3>
        <p data-id="element-98">
          Clean Slate Latina ofrece guías digitales en formato PDF. Al completar
          tu compra, recibirás acceso inmediato al producto a través de tu
          correo electrónico. El producto es para uso personal y no comercial.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-99">
          2. Propiedad Intelectual
        </h3>
        <p data-id="element-100">
          Todo el contenido de nuestras guías digitales, incluyendo texto,
          gráficos, diseños y metodologías, está protegido por derechos de
          autor. Queda prohibida la reproducción, distribución o reventa del
          material sin autorización expresa por escrito.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-101">
          3. Política de Reembolso
        </h3>
        <p data-id="element-102">
          Debido a la naturaleza digital e instantánea de nuestros productos,
          todas las ventas son finales. No ofrecemos reembolsos una vez que el
          producto ha sido entregado a tu correo electrónico. Si experimentas
          problemas técnicos para acceder al producto, estaremos encantados de
          ayudarte.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-103">
          4. Uso Permitido
        </h3>
        <ul className="list-disc pl-6 space-y-1" data-id="element-104">
          <li data-id="element-105">Puedes descargar e imprimir el material para tu uso personal</li>
          <li data-id="element-106">
            Puedes compartir los conceptos generales con familiares y amigos de
            forma verbal
          </li>
          <li data-id="element-107">No puedes redistribuir, copiar o vender el archivo digital</li>
          <li data-id="element-108">
            No puedes publicar el contenido en redes sociales o sitios web
          </li>
        </ul>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-109">
          5. Resultados
        </h3>
        <p data-id="element-110">
          Los resultados pueden variar según la dedicación y las circunstancias
          individuales de cada persona. Clean Slate Latina proporciona
          herramientas y métodos, pero no garantiza resultados específicos.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-111">
          6. Modificaciones
        </h3>
        <p data-id="element-112">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación en nuestro sitio web.
        </p>

        <h3 className="text-lg font-serif font-bold text-olive pt-2" data-id="element-113">
          7. Ley Aplicable
        </h3>
        <p data-id="element-114">
          Estos términos se rigen por las leyes de los Estados Unidos de
          América. Cualquier disputa será resuelta en los tribunales competentes
          de dicha jurisdicción.
        </p>
      </Modal>
    </>;
}